import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Gateway } from '@iotv/datamodel-core';
import { isPosition } from '@iotv/iotv-v3-types';
import { Stack } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { AppMainViewContext } from '../../../ContextProviders/AppContextProvider';
import { GoogleMapAPIMapTypeIds, useGoogleMap } from '../../../GoogleMapV4';
import { geoObjectCodec, isShimmedGeoObject } from '../../../GoogleMapV4/mapfns/ObjectConversion/validGeoObjectShims';
import { ShowDefinedEntriesOnlyOpts, UserTransactionType } from '../../../types/AppTypes';
import { ObjectDetailCard } from '../../../v2/components/generic/ObjectView/ObjectDetailCard';
import PhotosCard from '../../cards/PhotosCard';
const DetailsTab = (props) => {
    const { gateway: gatewayIn, mostProximateCustomer, transactionFunctions, userFunctions, allowedActions } = props;
    const [gateway, setGateway] = useState(gatewayIn);
    const [{ isSmallView }] = useContext(AppMainViewContext);
    const { components: { PortalDiv }, dispatch, map, state: { places }, } = useGoogleMap({
        showDrawingTools: true,
        functions: {
            saveFn: async (geoObjects) => {
                console.log('Gateway Details Tab used unhooked save fn');
                return { err: null, data: geoObjects };
            },
        },
        providedState: {
            options: { zoom: 16, center: isPosition(gateway.location) ? gateway.location : null, mapTypeId: GoogleMapAPIMapTypeIds.terrain },
        },
    });
    useEffect(() => {
        if (gatewayIn && isPosition(gatewayIn.location)) {
            const proxyGateway = geoObjectCodec.toGeoObject(gatewayIn);
            const action = {
                type: 'update',
                value: { subType: 'addPlaceToDatalayer', place: proxyGateway },
            };
            dispatch(action);
        }
    }, [gatewayIn]);
    useEffect(() => {
        console.log('Gateway Detail tab used effect on places');
        const proxyGateway = places.find((p) => p.id === gateway.id);
        if (isShimmedGeoObject(proxyGateway)) {
            const rehydratedGateway = geoObjectCodec.fromGeoObject(proxyGateway);
            rehydratedGateway && setGateway(new Gateway(rehydratedGateway));
            console.log('Gateway Detail got shimmed geoObject', rehydratedGateway);
        }
        else {
            console.log('Gateway Detail not shimmed', proxyGateway);
        }
    }, [places]);
    return (_jsxs(Stack, { direction: isSmallView ? 'column' : 'row', gap: 1, children: [_jsx(Stack, { minWidth: "50%", children: _jsx(ObjectDetailCard, { matchedPrimary: gateway, mostProximateCustomer: mostProximateCustomer, allowedActions: allowedActions, userFunctions: userFunctions, transactionFunctions: transactionFunctions, definedEntriesOnlyOpt: ShowDefinedEntriesOnlyOpts.Yes }) }, "details"), _jsxs(Stack, { flexGrow: 1, gap: 1, children: [isPosition(gateway.location) && map.current ? (_jsxs(Stack, { height: "80cqh", children: [PortalDiv, map.current] }, "map")) : null, _jsx(Stack, { children: _jsx(PhotosCard, { matchedPrimary: gateway, userFunctions, transactionFunctions, actions: [UserTransactionType.CREATE] }) }, "photos")] }, "aside")] }));
};
export default DetailsTab;
